import { NgModule } from '@angular/core';
import { MinutesToMHDPipe } from './minutes-to-mhd.pipe';

@NgModule({
    declarations: [MinutesToMHDPipe],
    exports: [MinutesToMHDPipe],
})
export class MinutesToMHDPipeModule {}
